import React, { useState, useEffect } from "react";
import Header from "../../Components/header";
import Footer from "../../Components/footer";
import aboutBanner from "../../assets/images/about-bg.jpg"
import "../../assets/css/style.scss";
import "./index.scss";

import { useDispatch, useSelector } from "react-redux"

import Swal from "sweetalert2";

import { Form } from 'react-bootstrap';

import { getCategory } from '../../Services/Category'
import { getProduct } from '../../Services/Product'
import { getCart, addToCart } from '../../Services/Cart'

import { defaultProduct } from "../..//Constant/index";

import banner from "../../assets/images/grocery-web-banner.jpg";
import product1 from "../../assets/images/product-1.png";
import product2 from "../../assets/images/product-2.png";
import product3 from "../../assets/images/product-3.png";
import product4 from "../../assets/images/product-4.png";
import cartIcon from "../../assets/images/cart-icon.svg";
import storeBanner from "../../assets/images/product-banner-store.jpg";
import loadingCart from "../../assets/images/loading-cart.gif";


import Login from '../../Components/Login'

import { vendor } from "../../Constant"

import { setCart } from "../../Redux/Slice/cartSlice"

import { TailSpin } from 'react-loader-spinner'
import { useNavigate } from "react-router-dom";
import ReactPaginate from 'react-paginate';

let pageSize = 10;


const Products = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { cart } = useSelector((state) => state)

    const [ToggleState, setToggleState] = useState(1);
    const [categories, setCategories] = useState([]);
    const [activeIndex, setActiveIndex] = useState('All');
    const [selectedcategory, setselectedCategory] = useState('All');
    const [products, setProducts] = useState([]);
    const [carts, setCarts] = useState([]);
    const [productsLoading, setProductsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [loginShow, setLoginShow] = useState(false);
    const [itemOffset, setItemOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);


    useEffect(() => {
        // dispatch(setCart([{test: 1}]))
        getProductData()
    }, [selectedcategory])

    useEffect(() => {
        getCategoryData()
        if (!localStorage.getItem("ownezzy-user-loggedIn")) return

        getCartData()
    }, [localStorage.getItem("ownezzy-user-loggedIn")])

    let getCategoryData = async () => {
        const response = await getCategory();
        setCategories(response.data)
    }

    let getProductData = async () => {
        setProductsLoading(true)
        const response = await getProduct(selectedcategory);
        setProducts(response.data.products)
        setProductsLoading(false)
    }

    let getCartData = async () => {
        setProductsLoading(true)
        const response = await getCart();
        dispatch(setCart(response.data))
        setProductsLoading(false)
    }


    const handeleCategory = (index) => {
        if (index == 'All') {
            setselectedCategory('All');
            setActiveIndex('All')
        } else {
            setselectedCategory(categories[index]._id);
            setActiveIndex(index)
        }
    };

    const getActiveClass = (index, className) =>
        ToggleState === index ? className : "";



    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);

    const onAddToCart = async (val, quantity) => {
        if (localStorage.getItem('ownezzy-user-loggedIn')) {
            let payload = {
                vendor: vendor,
                productId: val._id,
                quantity: quantity,
                cart:
                {
                    "prices": val.prices,
                    "image": val.image,
                    "_id": val._id,
                    "title": val.title.en,
                    "description": val.description,
                    "category": val.category,
                    "price": val.prices.price,
                    "originalPrice": val.prices.originalPrice,
                    "discount": val.prices.discount,
                    "quantity": quantity,
                    "itemTotal": val.prices.price * quantity

                }

            }
            const response = await addToCart(payload);
            if (response.status == 200) {
                getCartData()
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Item added to cart',
                    showConfirmButton: false,
                    timer: 1500,
                    heigth: '100px'
                })
            } else {

            }
        } else {
            setLoginShow(true)
        }
    }

    const gotoProducts = () => {
        navigate("/products")
    }

    const handlePageChange = (event) => {
        setCurrentPage(event.target);
        const newOffset = (event.selected * pageSize) % products.length;
        setItemOffset(newOffset);
        setProductsLoading(true);
        setTimeout(() => {
            setProductsLoading(false);
        }, [2000])
    };

    const endOffset = itemOffset + pageSize;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const paginatedData = products.slice(itemOffset, endOffset);

    return (
        <>
            <div className="wrapper">
                <Header />
                <Login loginShow={loginShow} setLoginShow={setLoginShow} />
                <div className="image-box-container" style={{ backgroundImage: `url(${aboutBanner})` }}>
                    <div className="overlay-colored-Bg"></div>
                    <div className="container">
                        <div className="center-content">
                            <div className="banner-title">
                                <h1>Products</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="pt-0 mb-4">

                    <div className="product-list-wigits">
                        <div className="container">
                            <div className="row">
                                <div className="col-3">
                                    <div className="left-sidebar">
                                        <div className="filter-heading">
                                            <span className=""><i className="fa fa-filter"></i> Filter By</span>
                                            {/* <button type="button" className="btn btn-theme btn-">Clear</button> */}
                                        </div>
                                        <div className="form-group mb-3">
                                            <label className="txt-label-login"><h5>Keyword</h5> </label>
                                            <input name='search' type="text" className="form-control input-web-txt" placeholder="Search" />
                                        </div>
                                        <br />

                                        <div className="form-group mb-3">
                                            <label className="txt-label-login"><h5>Category</h5></label>
                                            {/* <Form.Check type="checkbox" label="Check me out" /> */}
                                            {/* <input type="checkbox" label="Check me out" className="form-control input-web-txt" /> */}
                                            <Form className="category-box">
                                                <Form.Group controlId="formBasicCheckbox">
                                                    <Form.Check type="checkbox" label="Breakfast" />
                                                    <Form.Check type="checkbox" label="Lunch" />
                                                    <Form.Check type="checkbox" label="Dinner" />
                                                    <Form.Check type="checkbox" label="Meal" />
                                                    {/* <Form.Check type="checkbox" label="Grocery" /> */}
                                                    <Form.Check type="checkbox" label="Dairy" />

                                                </Form.Group>

                                            </Form>
                                        </div>
                                        <br />
                                        {/* <div className="form-group mb-3">
                                            <label className="txt-label-login"><h5>Brands</h5></label>
                                            <Form className="category-box">
                                                <Form.Group controlId="formBasicCheckbox">
                                                    <Form.Check type="checkbox" label="Patanjali" />
                                                    <Form.Check type="checkbox" label="Fortune" />
                                                    <Form.Check type="checkbox" label="Dairy" />
                                                    <Form.Check type="checkbox" label="Verka" />
                                                    <Form.Check type="checkbox" label="Amul" />
                                                </Form.Group>
                                            </Form>
                                        </div> */}
                                        <br />
                                        {/* <div className="form-group mb-3">
                                            <label className="txt-label-login"><h5>Price</h5></label>
                                            <Form className="category-box">
                                                <Form.Group controlId="formBasicCheckbox">
                                                    <Form.Label>From</Form.Label>
                                                    <Form.Control as="select">
                                                        <option>1</option>
                                                        <option>2</option>
                                                        <option>3</option>
                                                        <option>4</option>
                                                        <option>5</option>
                                                    </Form.Control>
                                                    <br />
                                                    <Form.Label>To</Form.Label>
                                                    <Form.Control as="select">
                                                        <option>1000</option>
                                                        <option>2000</option>
                                                        <option>3000</option>
                                                        <option>4000</option>
                                                        <option>5000</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Form>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-9">
                                    <div className="multi-products-elements">
                                        <div className="d-flex flex-wrap align-items-center justify-content-between mb-4">
                                            <div className="heading-product">
                                                <div className="form-group">
                                                    <input name='search' type="text" className="form-control input-web-txt" placeholder="Search" />


                                                </div>
                                            </div>
                                            <div className="product-tab-items">
                                                <ul className="tab-menu-bar mb-0">
                                                    <li onClick={() => handeleCategory('All')} className={`tabs-nav-menu ${activeIndex == 'All' ? 'active' : ''}`}>
                                                        <button type="button" className={`tabs-nav-link active-tabs`}
                                                        // onClick={() => toggleTab(1)}
                                                        >{'All'}</button>
                                                    </li>
                                                    {
                                                        categories && categories.map((val, i) => {
                                                            return (
                                                                <li key={i} onClick={() => handeleCategory(i)} className={`tabs-nav-menu ${activeIndex == i ? 'active' : ''}`}>
                                                                    <button type="button" className={`tabs-nav-link ${getActiveClass(1, "active-tabs")}`}
                                                                    //  onClick={() => toggleTab(1)}
                                                                    >{val.name.en}</button>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="product-wigit-wrapper">
                                            <div className="tabs-container">
                                                <div className={`tabs-panel-wap ${getActiveClass(1, "show")}`}>
                                                    <div className="element-gridproduct">
                                                        <div className="row">
                                                            {
                                                                productsLoading ?
                                                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '5%', marginBottom: '5%', alignItems: 'center', verticalAlign: 'middle', minHeight: '700px' }}>
                                                                        <TailSpin
                                                                            height="80"
                                                                            width="80"
                                                                            color="#4fa94d"
                                                                            ariaLabel="tail-spin-loading"
                                                                            radius="1"
                                                                            wrapperStyle={{}}
                                                                            wrapperClass=""
                                                                            visible={true}
                                                                        />
                                                                    </div>
                                                                    :
                                                                    paginatedData && paginatedData.map((val, i) => {
                                                                        return (
                                                                            <div className="col-6 col-md-3 pd-column">
                                                                                <div className="product-box-elemnt">
                                                                                    <div onClick={() => setShowModal(true)} className="product-content-area">
                                                                                        <div className="img-product-mt">
                                                                                            <img src={val.image.length ? val.image[0] : defaultProduct} alt="" />
                                                                                        </div>
                                                                                        <div className="product-disc-wt">
                                                                                            <h3 className="product-title-item">{val.title.en}</h3>
                                                                                            <div className="product-price">
                                                                                                <span className="cross-price">₹{val.prices.originalPrice}</span><span className="actual-price">₹{val.prices.price}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div onClick={() => onAddToCart(val, 1)} className="add-cart-btn mt-2 mt-md-3 px-2 px-lg-3 pb-3"><button type="button" className="btn btn-theme btn-cart-btn"><img src={cartIcon} alt="" />Add To Cart</button></div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                            }
                                                        </div>
                                                        {/* <div className="pagination-container">
                                                            <ReactPaginate
                                                                previousLabel={"Previous"}
                                                                nextLabel={"Next"}
                                                                pageCount={Math.ceil(products.length / pageSize)}
                                                                onPageChange={handlePageChange}
                                                            />
                                                        </div> */}
                                                    </div>
                                                </div>

                                                <div className={`tabs-panel-wap ${getActiveClass(6, "show")}`}>
                                                    <div className="element-gridproduct">
                                                        <div className="row">
                                                            <div className="col-12 col-md-3">
                                                                <div className="product-box-elemnt">
                                                                    <div className="img-product-mt">
                                                                        <img src={product3} alt="" />
                                                                    </div>
                                                                    <div className="product-disc-wt">
                                                                        <h3 className="product-title-item">Seeds of Change Organic Red Rice</h3>
                                                                        <div className="product-price">
                                                                            <span className="cross-price">₹75.00</span><span className="actual-price">₹59.00</span>
                                                                        </div>
                                                                        <div className="add-cart-btn mt-3"><button type="button" className="btn btn-theme btn-cart-btn"><img src={cartIcon} alt="" />Add To Cart</button></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-md-3">
                                                                <div className="product-box-elemnt">
                                                                    <div className="img-product-mt">
                                                                        <img src={product1} alt="" />
                                                                    </div>
                                                                    <div className="product-disc-wt">
                                                                        <h3 className="product-title-item">Seeds of Change Organic Red Rice</h3>
                                                                        <div className="product-price">
                                                                            <span className="cross-price">₹75.00</span><span className="actual-price">₹59.00</span>
                                                                        </div>
                                                                        <div className="add-cart-btn mt-3"><button type="button" className="btn btn-theme btn-cart-btn"><img src={cartIcon} alt="" />Add To Cart</button></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                </section>
                <Footer />
            </div>
        </>
    )
}
export default Products;